import React from 'react'
import Remainder from '../Components/Remainder/Remainder'

const RemainderView = () => {
  return (
    <div>
        <Remainder />
    </div>
  )
}

export default RemainderView